import {
  createPlugin,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
} from "@backstage/core-plugin-api";
import { HoneybadgerApi, honeybadgerApiRef } from "./api/HoneybadgerApi";
import { rootRouteRef } from "./routes";

export const honeybadgerApiPlugin = createPlugin({
  id: "honeybadger-api",
  apis: [
    createApiFactory({
      api: honeybadgerApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, identityApi }) =>
        new HoneybadgerApi({
          discoveryApi,
          identityApi,
        }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});
